import axios from "axios";

const b2cService = axios.create({
    baseURL: process.env.REACT_GIGI_API,
    timeout: 59000,
});
b2cService.defaults.headers.common["Content-Type"] = "application/json";

export default b2cService;